import { memo as Memo, useMemo } from 'react'

//* HOC's
import { withDataContext } from 'context'

//* Components
import Page from 'components/common/Page'
import Text from 'components/common/Text'
import Container from 'components/common/Container'

import CollapseItem from 'components/pages/Terms/CollapseItem'

//* Style
import TermsStyle from 'styles/pages/TermsStyle'

const Terms = Memo(({ pages, pageParams, selectedLang }) => {

    //! Page Data
    const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams.name])

    const storeCollapse = (conditions) => {
        return conditions?.map((el, ind) => {
            return <CollapseItem data={el} key={ind} />
        })
    }

    return pageData ? (
        <Page className='terms' meta={pageData.content.meta}>
            <TermsStyle>
                <Container>
                    <Text tag={'h3'} className={'h3 grandItalic'} text={pageData.content.terms.title} />
                    <Text tag={'h7'} className={'h7 geoRegular description'} text={pageData.content.terms.text} />
                    <div className='accordionWrapper'>{storeCollapse(pageData.content.terms.conditions)}</div>
                    <br />
                    <br />
                    <br />
                    <Text tag={'h3'} className={'h3 grandItalic'} text={pageData.content.general.title} />
                    <Text tag={'h7'} className={'h7 geoRegular description'} text={pageData.content.general.text} />
                    <div className='accordionWrapper'>{storeCollapse(pageData.content.general.conditions)}</div>
                </Container>
            </TermsStyle>
        </Page>
    ) : null
})

export default withDataContext(Terms, ['pages'])
